import React from "react";

import CommonStyle from "../common.module.css";
import EmailStyle from "./Email.module.css";

const Email = ({ change, email }) => (
  <div className={EmailStyle.emailContainer}>
    <input
      type="email"
      placeholder="Email address"
      name="email"
      value={email}
      onChange={change}
      className={`${CommonStyle.email} ${EmailStyle.email}`}
    />
  </div>
);

export default Email;
